import { postMessage } from '@/server/site-editor'

export default {
  state: {
    current: 'section', // 具体枚举含义见：views/site-edit/config/section-config。js
    isEdited: false, // 是否编辑过
    themeDto: null,
    IFRAME: null,
    previewMode: '1', // 预览模式，1：PC端，2:移动端，3:全屏模式
    tmpData: {
      type: 3,
      name: '',
      config: '',
      isPublish: 2,
      shopId: '',
      themeId: '',
      id: ''
    },
    sectionsData: {},
  },
  mutations: {
    resetStore(state) {
      state.current = 'section'
      state.isEdited = false
    },
    setCurrent(state, current) {
      state.current = current
    },
    setIsEdited(state, isEdited) {
      state.isEdited = isEdited
    },
    setPreviewMode(state, mode) {
      state.previewMode = mode
      // postMessage(state.IFRAME, { reload: true })
    },
    initTmpData(state, data) {
      state.tmpData = { ...state.tmpData, ...data }
    },
    initSectionsData(state, data) {
      state.sectionsData = { ...state.sectionsData, ...data }
    },
    initThemeDto(state, data) {
      state.themeDto = data
    },
    initIFRAME(state, data) {
      state.IFRAME = data
    },
    setCollectionContent(state, payload) {
      state.sectionsData[payload.sDomId].data[payload.key] = payload.value
      if (!state.isEdited) {
        state.isEdited = true
      }
      postMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
  },
}
